// ag-grid-enterprise v19.1.4
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ag_grid_community_1 = require("ag-grid-community");
var xf_1 = require("./xf");
var cellStylesXfsFactory = {
    getTemplate: function (xf) {
        return {
            name: "cellStyleXfs",
            properties: {
                rawMap: {
                    count: xf.length
                }
            },
            children: ag_grid_community_1._.map(xf, xf_1.default.getTemplate)
        };
    }
};
exports.default = cellStylesXfsFactory;



//////////////////
// WEBPACK FOOTER
// ./~/_ag-grid-enterprise@19.1.4@ag-grid-enterprise/dist/lib/exporter/files/ooxml/styles/cellStyleXfs.js
// module id = 768
// module chunks = 5